import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { createUrl } from '../../../services/CommonFunctions';
import MenuItems from '../../../constants/MenuItems';
import useApi from '../../../hooks/useApi';
import { uzivatelOdhlaseni } from '../../../api';
import { useToken } from '../../../hooks/TokenStorage';

interface IAppMenuProps {
}

function AppMenu(props: IAppMenuProps) {
    const [open, setOpen] = useState(true);
    const { setToken } = useToken();
    const { call, error} = useApi<void, void>(uzivatelOdhlaseni());

    return (
        <div id='app-menu'>
            <div
                className='expander cursor-pointer'
                onClick={() => setOpen(!open)}>
                <FontAwesomeIcon
                    icon={icon({ name: 'bars' })}
                    size='lg' />
            </div>

            {
                open &&
                <div className='content'>
                    {
                        MenuItems.map(({ label, path }) => {
                            const className = ['menu-item', 'cursor-pointer'];
                            if (window.location.hash === path) className.push('active');

                            return (
                                <a
                                    key={path}
                                    className={className.join(' ')}
                                    href={createUrl(path)}>
                                    {label}
                                </a>
                            );
                        })
                    }
                    <span
                        style={{ color: 'red' }}
                        className='menu-item cursor-pointer'
                        onClick={async () => {
                            // eslint-disable-next-line no-restricted-globals
                            if (confirm('Opravdu chcete odhlásit?') === true) {
                                const resp = await call();
                                setToken(undefined);
                                if (!resp && error) alert('err ' + error?.message);                                
                            }
                        }}>
                        Odhlásit
                    </span>
                </div>
            }
        </div >
    );

}

export default AppMenu;
